"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Affinity = void 0;
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Affinity extends useStore_entities_1.Entity {
    static cache = true;
    static create = (attributes) => ({
        api: 'v1',
        content: {
            level: attributes['level'],
            motivation: attributes['motivation'],
            skill: {
                id: attributes['skill']['id'],
            },
        },
        method: 'POST',
        route: '/people/me/skills_affinities',
    });
    static update = (attributes) => ({
        api: 'v1',
        content: {
            level: attributes['level'],
            motivation: attributes['motivation'],
            skill: {
                id: attributes['skill']['id'],
            },
        },
        method: 'PUT',
        route: `/people/me/skills_affinities/${attributes.id}`,
    });
    static destroy = (attributes) => ({
        api: 'v1',
        method: 'DELETE',
        route: `/people/me/skills_affinities/${attributes.id}`,
    });
}
exports.Affinity = Affinity;
//# sourceMappingURL=Affinity.js.map